import fs from 'node:fs';
import path from 'node:path';
import { fileURLToPath } from 'node:url';

/**
 * Locate the @sortlist/cli package root by walking up from this module.
 * Relative `import.meta.url` paths break once the source is bundled into
 * dist/, so root-relative files (.published, package.json) must be resolved
 * through this instead.
 */
function findPackageRoot(): string {
  let dir = path.dirname(fileURLToPath(import.meta.url));
  while (true) {
    const pkgPath = path.join(dir, 'package.json');
    if (fs.existsSync(pkgPath)) {
      try {
        const parsed = JSON.parse(fs.readFileSync(pkgPath, 'utf-8')) as { name?: string };
        if (parsed.name === '@sortlist/cli') return dir;
      } catch {
        // unreadable package.json — keep walking
      }
    }
    const parent = path.dirname(dir);
    if (parent === dir) throw new Error('Could not locate the @sortlist/cli package root');
    dir = parent;
  }
}

export const packageRoot = findPackageRoot();

export const pkg = JSON.parse(fs.readFileSync(path.join(packageRoot, 'package.json'), 'utf-8')) as {
  name: string;
  version: string;
};
